module.exports = __webpack_public_path__ + "img/iometeca__logo.172720a3.svg";